import React from "react";
import Intro from "../components/home/intro";
import Video from "../components/home/video";
import Services from "../components/home/services";
import GoalSaving from "../components/home/goalSaving";
import MemberCarousel from "../components/home/memberCarousel";
import DownloadReferral from "../components/home/downloadReferral";
import { Box } from "@mui/material";
import Strings from "../utils/stringUtil";
import Seo from "../components/seo";
import { isMobile } from "../utils/responsiveUtil";
import withLoader from "../components/ui/withLoader";
import { homeSchemaMarkup } from "../utils/schemaUtil";

function Home() {
  return (
    <React.Fragment>
      <Seo
        title={Strings.homeMetaTitle}
        description={Strings.homeMetaDescription}
        keywords={Strings.homeMetaKeyword}
        schema={homeSchemaMarkup}
      />
      <Box mt={isMobile ? 2 : 5}>
        <Intro />
        <Video />
        <Services />
        <GoalSaving />
        <MemberCarousel />
        <DownloadReferral />
      </Box>
    </React.Fragment>
  );
}

export default withLoader(Home);
